// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Universe Sonic Universe - Main Export
 * 
 * Aggregates all configuration for the Sonic Universe.
 * A universe of speed, rings, and chaos emeralds where going fast is life.
 */

import { starSystems, starPositions } from './StarSystemsConfig';
import { warpGates, warpGatePositions } from './WarpGatesConfig';
import { SonicUniverseAliensPlanets } from './AliensConfig';

export const universeSonicUniverse = {
  id: 'sonicuniverse',
  starSystems,
  starPositions,
  warpGates,
  warpGatePositions,
  aliens: SonicUniverseAliensPlanets,
};

export default universeSonicUniverse;